/* @flow */

import * as React from 'react';

import {type FieldProps} from 'redux-form';

import {FormField} from 'shells/form';
import {TextField} from 'shells/textfield';

import {getReduxFormError} from './helpers';
import {TinyIntroCompanyLogo} from './tiny-intro-company-logo';

import './tiny-intro-company-name-logo.module.css';

type BaseProps = {|
    title: string,
    isRequired?: boolean,
    size?: 'normal' | 'big',
|};

type ReduxFormProps = {|
    ...BaseProps,
    variant: 'redux-form',
    companyLogoUrl: FieldProps,
    companyName: FieldProps,
|};

type ControlledProps = {|
    ...BaseProps,
    variant: 'controlled',
    companyName: string,
    companyLogoUrl: ?string,
    onCompanyNameChange: (value: string) => void,
    onCompanyLogoUrlChange: (value: ?string) => void,
    error?: ?string,
|};

type Props = ReduxFormProps | ControlledProps;

export function TinyIntroCompanyNameLogo(props: Props) {
    const {size = 'big'} = props;

    const companyLogoUrlValue =
        props.variant === 'redux-form' ? props.companyLogoUrl.input.value : props.companyLogoUrl;
    const onCompanyLogoUrlChange =
        props.variant === 'redux-form'
            ? props.companyLogoUrl.input.onChange
            : props.onCompanyLogoUrlChange;
    const name = props.variant === 'redux-form' ? props.companyName.input.name : 'companyName';
    const error =
        props.variant === 'redux-form' ? getReduxFormError(props.companyName.meta) : props.error;
    const hasError =
        props.variant === 'redux-form'
            ? Boolean(props.companyName.meta.error && props.companyName.meta.submitFailed)
            : Boolean(props.error);

    // Spread additional input props (onBlur, onFocus, etc.) for redux-form variant
    const companyNameInputProps =
        props.variant === 'redux-form'
            ? props.companyName.input
            : {value: props.companyName, onChange: props.onCompanyNameChange, name};

    return (
        <FormField
            innerId={name}
            label={props.title}
            errorMessage={error}
            isRequired={props.isRequired}
        >
            <div styleName='company-container'>
                {companyLogoUrlValue && (
                    <TinyIntroCompanyLogo
                        logoUrl={companyLogoUrlValue}
                        onRemove={() => {
                            onCompanyLogoUrlChange(null);
                        }}
                    />
                )}
                <TextField
                    type='text'
                    {...companyNameInputProps}
                    id={name}
                    hasError={hasError}
                    placeholder='ExampleCo'
                    focusOnMount={true}
                    size={size}
                />
            </div>
        </FormField>
    );
}
